import type { JSX } from 'react';
import styles from './EmptyState.module.scss';

export function EmptyState({ message }: { message: string }): JSX.Element {
  return <div className={styles.emptyState}>{message}</div>;
}
